export default __webpack_public_path__ + "30ee56a6b91457fd52c9186e42a78397.svg";